import React from 'react'
import styles from './OnboardingOverlay.scss'
import ReactModal from 'react-modal'
import {base, interfaceBase} from 'lib/styleguide/base.scss'
import {Icon} from 'common/Icon'
import {Topo} from 'common/styleguide/Topo'
import {CTA} from 'common/styleguide/CTA'
import {ModalOverlay} from 'common/styleguide/ModalOverlay'
import {Pips} from 'common/Pips'
import cx from 'classnames'
import blueTheme from 'common/styleguide/ModalOverlay/blueHeaderModalTheme.scss'

export class OnboardingOverlay extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      stepIndex: props.introStep ? -1 : 0
    }
  }

  next = () => {
    const {steps} = this.props
    this.setState({
      stepIndex: Math.min(this.state.stepIndex + 1, steps.length - 1)
    })
  }

  onClickPip = (index) => {
    const {steps} = this.props
    this.setState({
      stepIndex: index % steps.length // being a little defensive here
    })
  }

  getCore = () => {
    return document.getElementById('rwgps-ui-core')
  }

  render () {
    const {introStep, steps, onRequestClose} = this.props
    const {stepIndex} = this.state

    if (stepIndex === -1) {
      return <ModalOverlay
        title={introStep.heading}
        theme={blueTheme}
        shouldCloseOnOverlayClick={false}
        maxWidth={600}
        footer={introStep.footer(this.next)}
        onRequestClose={onRequestClose}>
        <div style={{textAlign: 'center'}}>
          {introStep.content}
        </div>
      </ModalOverlay>
    }
    const step = steps[stepIndex]
    return (
      <ReactModal
        className={styles.overlay}
        style={{overlay: {background: 'none', zIndex: 901}}}
        overlayClassName={styles.container}
        isOpen
        appElement={this.getCore()}
        contentLabel='OnboardingOverlay'
        shouldCloseOnOverlayClick={false}
        onRequestClose={onRequestClose}>
        <Scrim targetId={step.targetId} />
        <Content
          step={step}
          lastStep={stepIndex === steps.length - 1}
          onRequestClose={onRequestClose}
          onClickNext={this.next}
          pips={<Pips stepCount={steps.length} activeIndex={stepIndex} onClickPip={this.onClickPip} />} />
      </ReactModal>
    )
  }
}

class Scrim extends React.PureComponent {
  state = {
    top: null,
    left: null,
    height: null,
    width: null
  }

  componentDidMount () {
    this.updatePosition()
  }

  componentDidUpdate () {
    this.updatePosition()
  }

  updatePosition = () => {
    const {targetId} = this.props
    const target = document.getElementById(targetId)
    if (!target) {
      this.setState({
        top: null,
        left: null,
        height: null,
        width: null
      })
      return
    }
    target.scrollIntoView(false) // safari doesn't support passing options to scrollIntoView
    const top = target.getBoundingClientRect().top + document.body.scrollTop
    const left = target.getBoundingClientRect().left
    const width = target.clientWidth
    const height = target.clientHeight
    this.setState({top, left, width, height})
  }

  render () {
    const {top, left, width, height} = this.state
    if (![top, left, width, height].every(n => Number.isFinite(n))) { return null }
    return <div className={styles.Scrim} style={{top, left, width, height}} />
  }
}

class Content extends React.PureComponent {
  render () {
    const {step, onRequestClose, onClickNext, lastStep, pips} = this.props
    return (
      <Topo dark className={cx(styles.Content, base, interfaceBase, step.alignLeft && styles.ContentLeft)}>
        <div className={styles.closeButton}>
          <Icon i='md-close' size={24} onClick={onRequestClose} />
        </div>
        <div className={styles.alignCenter}>
          <div className={styles.inner}>
            <h2>{step.heading}</h2>
            {step.content}
            {lastStep
              ? <CTA inline margins={false} onClick={onRequestClose}>Done</CTA>
              : <CTA inline margins={false} onClick={onClickNext}>Next</CTA>}
          </div>
        </div>
        <div className={styles.pips}>
          {pips}
        </div>
      </Topo>
    )
  }
}
